import { render } from "./VdiViewer.vue?vue&type=template&id=41f8413c"
import script from "./VdiViewer.vue?vue&type=script&lang=js"
export * from "./VdiViewer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__